import {jwtDecode, JwtPayload } from 'jwt-decode';
import { DateTime, Settings } from 'luxon';

export function decodeToken(token: string): JwtPayload | null {
  try {
    const decodedToken = jwtDecode(token) as JwtPayload;
    return decodedToken;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
}

export function decodeBase64(base64: string | undefined): string | null {
  if (!base64) return null;
  try {
      return atob(base64);
  } catch (error) {
      console.error('Error decoding Base64:', error);
      return null;
  }
}

export function decodeTokenCast<T>(token: string): T | null | undefined{
    try {
      const decodedToken = jwtDecode(token) as T;
      return decodedToken;
    } catch (error) {
      console.error('Error decoding token:', error);
      return undefined;
    }
}

export function parseJwt (token:any) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
}

export const expirationTokenAuth = (token: string): boolean => {
    Settings.defaultZone = 'America/Guayaquil';
    Settings.defaultLocale = 'es';
    const obj: any = jwtDecode<{ id: string, username: string, nombres: string, apellidos: string, email: string }>(token);
    const nowInGuayaquil = DateTime.now().toMillis();
    // Convertir timestamps a objetos DateTime
    const date1 = DateTime.fromSeconds(obj.exp);
    const date2 = DateTime.fromMillis(nowInGuayaquil);
    return date1 < date2;
}